/**
 * Allows to recognize the property type as a string literal type.
 */
function set<T extends string>(value: T) {
    return value;
}

export const CRM_PERMISSION = {
    CASINO_FREESPIN_CAMPAIGNS_INDEX: set('view freespin campaigns'),
    CASINO_FREESPIN_CAMPAIGNS_SHOW: set('show freespin campaign'),
    CASINO_FREESPIN_CAMPAIGNS_CREATE: set('create freespin campaign'),
    CASINO_FREESPIN_CAMPAIGNS_EDIT: set('edit freespin campaign'),

    REPORTS_GGR_INDEX: set('view ggr reports'),

    GAME_CATEGORIES_INDEX: set('view game categories'),
    GAME_CATEGORY_SHOW: set('show game category'),
    GAME_CATEGORY_EDIT: set('edit game category'),
    GAME_CATEGORY_DELETE: set('delete game category'),
    GAME_CATEGORY_CREATE: set('create game category'),
    GAME_CATEGORY_INSERT_GAME: set('insert game to category'),
    GAME_CATEGORY_DELETE_GAME: set('delete game from category'),

    GAME_CATEGORY_BLOCKS_INDEX: set('view game category blocks'),
    GAME_CATEGORY_BLOCKS_EDIT: set('edit game category block'),
    GAME_CATEGORY_BLOCKS_DELETE: set('delete game category block'),
    GAME_CATEGORY_BLOCKS_CREATE: set('create game category block'),

    FREESPIN_PAGE_INDEX: set('view freespin pages'),
    FREESPIN_PAGE_SHOW: set('show freespin page'),
    FREESPIN_PAGE_EDIT: set('edit freespin page'),
    FREESPIN_PAGE_DELETE: set('delete freespin page'),
    FREESPIN_PAGE_CREATE: set('create freespin page'),

    TOURNAMENT_INDEX: set('view tournaments'),
    TOURNAMENT_SHOW: set('show tournament'),
    TOURNAMENT_EDIT: set('edit tournament'),
    TOURNAMENT_DELETE: set('delete tournament'),
    TOURNAMENT_CREATE: set('create tournament'),

    DEPOSIT_BONUS_INDEX: set('view deposit bonuses'),
    DEPOSIT_BONUS_SHOW: set('show deposit bonus'),
    DEPOSIT_BONUS_CREATE: set('create deposit bonus'),
    DEPOSIT_BONUS_EDIT: set('edit deposit bonus'),
    DEPOSIT_BONUS_DELETE: set('delete deposit bonus'),

    GAME_CREATORS_INDEX: set('view game creators'),
    GAME_CREATORS_SHOW: set('show game creator'),

    GAME_EDIT: set('edit game'),

    CASINO_SETTINGS_INDEX: set('view casino settings'),
    CASINO_SETTINGS_GAMES_EDIT: set('edit casino games settings'),
    CASINO_SETTINGS_TEMPLATE_EDIT: set('edit casino template settings'),
    CASINO_SETTINGS_SEO_EDIT: set('edit casino seo settings'),

    CASINO_DASHBOARD_INDEX: set('view casino dashboard'),
    CASINO_SLIDERS_VIEW: set('viewAny casino_slider'),
    CASINO_SLIDER_VIEW: set('view casino_slider'),
    CASINO_SLIDER_ITEM_VIEW: set('view casino_slider_item'),
    CASINO_SLIDER_ITEM_CREATE: set('create casino_slider_item'),
    CASINO_SLIDER_ITEM_DELETE: set('delete casino_slider_item'),
    CASINO_SLIDER_ITEM_EDIT: set('edit casino_slider_item'),

    CASINO_TRANSACTIONS_VIEW: set('view casino transactions'),

    INDEX_DEPOSIT_BONUS_PAGE: set('view deposit bonus pages'),
    SHOW_DEPOSIT_BONUS_PAGE: set('show deposit bonus page'),
    CREATE_DEPOSIT_BONUS_PAGE: set('create deposit bonus page'),
    EDIT_DEPOSIT_BONUS_PAGE: set('edit deposit bonus page'),
    DELETE_DEPOSIT_BONUS_PAGE: set('delete deposit bonus page'),

    INDEX_CASINO_GAME_CREATOR_SEO: set('view casino game creator seo'),
    SHOW_CASINO_GAME_CREATOR_SEO: set('show casino game creator seo'),
    CREATE_CASINO_GAME_CREATOR_SEO: set('create casino game creator seo'),
    EDIT_CASINO_GAME_CREATOR_SEO: set('edit casino game creator seo'),
    DELETE_CASINO_GAME_CREATOR_SEO: set('delete casino game creator seo'),

    NEWS_GAMES_WIDGET_INDEX: set('view casino news games widget'),
    NEWS_GAMES_WIDGET_CREATE: set('create casino news games widget'),
    NEWS_GAMES_WIDGET_DELETE: set('delete casino news games widget'),
};
